import type { IconProps } from "@/types/icon";

const FileIcon = ({ color = "#4D0FFF", className }: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M2.3999 4C2.3999 1.79086 4.19076 0 6.3999 0H14.3999L21.5999 7.2V20C21.5999 22.2091 19.809 24 17.5999 24H6.3999C4.19076 24 2.3999 22.2091 2.3999 20V4Z"
      fill={color}
    />
    <path
      opacity="0.3"
      d="M14.3999 0L21.5999 7.2H18.3999C16.1908 7.2 14.3999 5.40914 14.3999 3.2V0Z"
      fill="white"
    />
    <path
      d="M15.0447 15.1169C14.4458 15.1169 13.6964 15.2214 13.4512 15.2581C12.4364 14.1984 12.1477 13.596 12.0828 13.4355C12.1708 13.2093 12.477 12.3503 12.5205 11.2471C12.5419 10.6947 12.4253 10.2819 12.1736 10.0203C11.9223 9.75908 11.6182 9.73877 11.531 9.73877C11.2253 9.73877 10.7123 9.89339 10.7123 10.9288C10.7123 11.8272 11.1312 12.7805 11.247 13.0269C10.6369 14.8031 9.982 16.0191 9.84292 16.2691C7.39164 17.1921 7.19995 18.0844 7.19995 18.3373C7.19995 18.7918 7.52363 19.0632 8.06578 19.0632C9.38299 19.0632 10.585 16.8517 10.7838 16.4677C11.7193 16.0949 12.9715 15.864 13.2898 15.8089C14.2028 16.6787 15.2588 16.9108 15.6973 16.9108C16.0272 16.9108 16.7999 16.9108 16.7999 16.1164C16.7999 15.3786 15.8544 15.1169 15.0447 15.1169ZM14.9812 15.6384C15.6927 15.6384 15.8807 15.8737 15.8807 15.9981C15.8807 16.0762 15.8511 16.3309 15.4697 16.3309C15.1277 16.3309 14.5373 16.1333 13.9564 15.7044C14.1986 15.6726 14.5571 15.6384 14.9812 15.6384ZM11.4937 10.2443C11.5586 10.2443 11.6013 10.2651 11.6365 10.314C11.8411 10.5979 11.6761 11.5257 11.4753 12.2517C11.2814 11.6292 11.136 10.674 11.3406 10.3379C11.3807 10.2723 11.4264 10.2443 11.4937 10.2443ZM11.1482 15.8015C11.4057 15.2812 11.6945 14.5228 11.8517 14.0938C12.1664 14.6206 12.5897 15.1096 12.8345 15.3747C12.0723 15.5354 11.4956 15.696 11.1482 15.8015ZM7.71163 18.4068C7.69466 18.3866 7.69215 18.3442 7.70494 18.2933C7.73176 18.1865 7.9367 17.6574 9.41904 16.9943C9.20678 17.3286 8.87497 17.8063 8.51044 18.1632C8.25385 18.4034 8.05404 18.5252 7.91658 18.5252C7.8674 18.5252 7.79964 18.5118 7.71163 18.4068Z"
      fill="white"
    />
  </svg>
);

export default FileIcon;
